import React, { useState } from "react";
import { MDBBtn, MDBInput, MDBSpinner, MDBTextArea } from "mdb-react-ui-kit";
import ChipInput from "material-ui-chip-input";

import AddFileButton from "../Button/AddFileButton";
import { toast } from "react-toastify";
import { handleUploadFile } from "../../Utils/uploadHelper";
import { connect, useDispatch } from "react-redux";
import { addPost, getPost } from "../../Containers/PostContainer/action";
import { createStructuredSelector } from "reselect";

import styles from "./style.module.scss";
import { selectIsLoading } from "../../Containers/App/selector";
import ProfilePicture from "../ProfilePicture";
import ImageContainer from "../ImageContainer";
import { removeItemArrayByIndex } from "../../Utils/arrayHelper";
import { useLocation } from "react-router-dom";
import { selectProfile } from "../../Containers/Client/selector";

function FormPostAdd({ isLoading, isModal, onClose, profilePicture, profile }) {
	const initialState = {
		title: "",
		description: "",
		tags: [],
		files: [],
	};
	const [formData, setFormData] = useState(initialState);
	const { title, description, tags } = formData;
	const [files, setFiles] = useState([]);
	const dispatch = useDispatch();
	const location = useLocation();

	const formNotNull = () => {
		return !!(
			formData.description ||
			formData.tags.length > 0 ||
			formData.title ||
			files.length > 0
		);
	};
	const onSuccessSubmit = () => {
		const pathname = location.pathname;
		let page = null;
		if (pathname === "/") page = "myjourney";
		if (pathname === "/timeline") page = "timeline";
		if (pathname === "/explore") page = "explore";
		onClearForm();
		toast.success("Mark Successfully added!");
		if (page) {
			dispatch(getPost(page, pathname === "/" ? profile.username : null));
		}
	};
	const onUploadFile = async (e) => {
		const newFile = await handleUploadFile(e);
		setFiles([...files, ...newFile]);
	};
	const onClickSubmit = () => {
		for (const file of files) {
			formData.files.push(file.base64);
		}
		dispatch(addPost(formData, onSuccessSubmit));
	};
	const onInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
	const onAddTag = (tag) => {
		setFormData({ ...formData, tags: [...formData.tags, tag] });
	};
	const onDeleteTag = (deleteTag) => {
		setFormData({
			...formData,
			tags: [...formData.tags.filter((tag) => tag !== deleteTag)],
		});
	};
	const onClearForm = () => {
		setFormData({ title: "", tags: [], description: "", files: [] });
		setFiles([]);
	};
	const deleteImage = (index) => {
		setFiles([...removeItemArrayByIndex(files, index)]);
	};
	const getId = () => {
		if (isModal) {
			return "contained-button-file";
		}
		return "contained-button-file-modal";
	};
	return (
		<div className={styles.container}>
			<div className='d-flex justify-content-center w-100 '>
				<h5>How is it?</h5>
			</div>
			<div className='mb-2'>
				<MDBInput
					className={styles.inputField}
					label='Title'
					name='title'
					id='title'
					value={title}
					onChange={onInputChange}
				/>
			</div>
			<div className='mb-2'>
				<MDBTextArea
					className={styles.inputField}
					rows={formNotNull() ? 8 : 3}
					label='Description'
					value={description}
					name='description'
					id='description'
					onChange={onInputChange}
				></MDBTextArea>
				<input
					type='file'
					accept='image/*'
					multiple
					style={{ display: "none" }}
					id={getId()}
					onChange={onUploadFile}
					className={styles.inputField}
				/>
				<label htmlFor={getId()}>
					<AddFileButton />
				</label>
				<div className={styles.files}>
					{files.length > 0
						? files.map((data, index) => {
								return (
									<ImageContainer
										url={data.blob}
										isPostForm={true}
										action={() => deleteImage(index)}
										deleteOption={true}
									/>
								);
						  })
						: ""}
				</div>
			</div>
			<div>
				Tags:
				<ChipInput
					className={styles.inputField}
					variant='outlined'
					fullWidth
					name='tags'
					onAdd={(tag) => onAddTag(tag)}
					value={tags}
					allowDuplicates={false}
					onDelete={(tag) => onDeleteTag(tag)}
				/>
			</div>
			<div className='d-flex mt-3 justify-content-end w-100'>
				<div className='me-3'>
					<ProfilePicture isPost={true} url={profilePicture} />
				</div>
				{isModal || formNotNull() ? (
					<MDBBtn
						type='button'
						className='btn btn-danger me-2'
						onClick={formNotNull() ? onClearForm : isModal ? onClose : ""}
					>
						{formNotNull() ? "Clear" : "Close"}
					</MDBBtn>
				) : (
					""
				)}
				<MDBBtn
					type='button'
					disabled={formNotNull() ? false : true}
					className='btn'
					style={{ backgroundColor: "#ffa500" }}
					onClick={onClickSubmit}
				>
					{isLoading && (
						<MDBSpinner size='sm' role='status' tag='span' className='me-2' />
					)}
					Mark
				</MDBBtn>
			</div>
		</div>
	);
}

const mapStateToProps = createStructuredSelector({
	isLoading: selectIsLoading,
	profile: selectProfile,
});

export default connect(mapStateToProps)(FormPostAdd);
